import { $axios } from "../../config/axios";
import Pond from "../../model/pond";
import PondsService from "../../services/PondsService";
import { findIndex, nth, cloneDeep } from "lodash";
import { ABW, Samples } from "../../model/abw";
// import Axios from "axios";
import moment from "moment";
import { alphaNumericComparator } from "@/utils/commonUtils";
// import appConfig from "@/config/app";

const state = {
  ponds: [],
  activePonds: [],
  inactivePonds: [],
  lowDoPondCount: 0,
  unstablePhPondsCount: 0,
  withoutSchedulesPondsCount: [],
  mapPondidPond: new Map(),
  abwSummary: [],
  mapPondDrawnPlace: "",
  feedTypes: [],
  healthData: [],
  currentPondData: {},
  loading: false,
  manualFeedRecords: [],
  aPondManualFeedRecords: [],
  pondWiseDeviceStatus: [],
};
const getters = {
  getManualFeedRecords: (state) => state.manualFeedRecords,
  getAPondManualFeedRecords: (state) => state.aPondManualFeedRecords,
  getPonds: (state) => {
    return state.ponds;
  },
  getActivePonds: (state) => state.activePonds,
  getInactivePonds: (state) => state.inactivePonds,
  getLowDoPondCount: (state) => state.lowDoPondCount,
  getUnstablePhPondsCount: (state) => state.unstablePhPondsCount,
  getWithoutSchedulesPondsCount: (state) => state.withoutSchedulesPondsCount,
  getMapPondidPond: (state) => state.mapPondidPond,
  getPondsObj: (state) => {
    const pondsObj = {};

    state.ponds.forEach((pond) => {
      pondsObj[pond._id] = pond;
    });
    return pondsObj;
  },
  getObjPondIdPondWithPmsAndMode: (state, getters, rootState, rootGetters) => {
    const objPondIdPond = {};
    getters.getMapPondidPond.forEach((pond, pond_id) => {
      const newPond = cloneDeep(pond);
      if (
        newPond.pond_mothers.length &&
        (rootGetters["pondmother/getPmIdPm"] || new Map()).size
      ) {
        const pond_mothers = newPond.pond_mothers;
        const newPms = [];
        const pondMode = { farmer: 0, shrimp_talk: 0, manual: 0 };
        for (let i = 0; i < pond_mothers.length; i++) {
          const pm = rootGetters["pondmother/getPmIdPm"].get(
            pond_mothers[i]._id
          );
          if (pm) {
            newPms.push(pm);
            pondMode[pm && pm.managed_by] = 1;
          }
        }
        newPond.pond_mothers = newPms;
        const managedByKeys = Object.keys(pondMode).filter(
          (key) => pondMode[key] === 1
        );
        newPond.managed_by =
          managedByKeys.length > 1 ? "NONE" : managedByKeys[0];
      }
      objPondIdPond[pond._id] = newPond;
    });
    return objPondIdPond;
  },
  getObjPondIdPondHealthData: (state) => {
    const objPondIdPondHealthData = {};
    state.healthData.forEach((pondHealthData) => {
      objPondIdPondHealthData[pondHealthData._id] = pondHealthData;
    });
    return objPondIdPondHealthData;
  },
  getArrPondDataWithHealth: (state, getters) => {
    return getters.getPonds.map((pond) => {
      const nPondObj = cloneDeep(pond);
      const objPondHealthData = getters.getObjPondIdPondHealthData;
      const data = objPondHealthData[nPondObj._id];
      Object.keys(data || {}).forEach((key) => {
        nPondObj[key] = data[key];
      });
      return nPondObj;
    });
  },
  getObjPondDataWithHealth: (state, getters) => {
    const objPondDataWithHealth = {};
    state.ponds.forEach((pond) => {
      const nPondObj = cloneDeep(pond);
      const objPondHealthData = getters.getObjPondIdPondHealthData;
      const data = objPondHealthData[nPondObj._id];
      Object.keys(data || {}).forEach((key) => {
        nPondObj[key] = data[key];
      });
      objPondDataWithHealth[nPondObj._id] = nPondObj;
    });
    return objPondDataWithHealth;
  },
  getPondsInCulture: (state, getters, rootState, rootGetters) => {
    const userTimeZoneOffset = rootGetters["user/getUserTimeZoneOffset"];
    const utcISOString = moment()
      .utc()
      .startOf("day")
      .utcOffset(userTimeZoneOffset)
      .toISOString();
    return state.ponds.filter(
      (pond) =>
        pond.status === "ACTIVE" &&
        pond.post_larva_stocked > 0 &&
        pond.cultivation_date != null &&
        pond.cultivation_date !== utcISOString
    );
  },
  getpondHavingABWWithAbwValues(state, getters, rootState, rootGetters) {
    const abwValues = state.abwSummary || [];
    const pondIds = abwValues.map((abw) => abw.pond_id);
    if (abwValues.length > 0) {
      const pondHavingABW = {};
      getters.getMapPondidPond.forEach((pond, key) => {
        if (pond.status === "ACTIVE") {
          const abwIndex = pondIds.indexOf(key);
          const abwObj = new ABW();
          abwObj.pond_id = key;
          abwObj.cultivation_date = pond.cultivation_date;
          abwObj.modified = false;
          if (abwIndex > -1) {
            if (abwValues[abwIndex].abw_data.last_abw_date != null) {
              abwObj.last_abw = abwValues[abwIndex].abw_data.last_abw;
              abwObj.last_abw_date = abwValues[abwIndex].abw_data.last_abw_date;
              abwObj.weight_gain = abwValues[abwIndex].abw_data.abw
                ? abwValues[abwIndex].abw_data.abw - abwObj.last_abw
                : 0;
            }
            const sampleSize = (abwValues[abwIndex].abw_data.samples || [])
              .length;
            abwObj.samples =
              sampleSize > 0
                ? abwValues[abwIndex].abw_data.samples
                : [new Samples()];
            abwObj.abw = abwValues[abwIndex].abw_data.abw;

            abwObj.survival_percentage =
              abwValues[abwIndex].abw_data.survival_percentage || 100;
          }
          pondHavingABW[key] = abwObj;
        }
      });
      return pondHavingABW;
    }
    return {};
  },
  getPondIDsHavingABW(state) {
    const abwValues = state.abwSummary || [];
    const pondIds = abwValues.map((abw) => abw.pond_id);
    return pondIds;
  },
  getCurrentPondData(state) {
    return state.currentPondData;
  },
  getPondWiseDeviceStatus(state) {
    return state.pondWiseDeviceStatus;
  },
};
const mutations = {
  SET_PONDS_WITHOUT_SCHEDULES_COUNT(state, countData) {
    if (countData != null) {
      // const pondArr = 0;
      // pondsData.forEach((pond) => {
      //   const pondObj = new Pond();
      //   pondObj.castToPondObj(pond);
      //   pondArr.push(pondObj);
      // });
      state.withoutSchedulesPondsCount = countData;
    } else {
      state.withoutSchedulesPondsCount = null;
    }
  },
  SET_UNSTABLE_PH_PONDS_COUNT(state, countData) {
    if (countData != null) {
      // const pondArr = 0;
      // pondsData.forEach((pond) => {
      //   const pondObj = new Pond();
      //   pondObj.castToPondObj(pond);
      //   pondArr.push(pondObj);
      // });
      state.unstablePhPondsCount = countData;
    } else {
      state.unstablePhPondsCount = null;
    }
  },
  SET_LOW_DO_PONDS_COUNT(state, countData) {
    if (countData != null) {
      // const pondArr = 0;
      // pondsData.forEach((pond) => {
      //   const pondObj = new Pond();
      //   pondObj.castToPondObj(pond);
      //   pondArr.push(pondObj);
      // });
      state.lowDoPondCount = countData;
    } else {
      state.lowDoPondCount = null;
    }
  },
  SET_PONDS_DATA(state, pondsData) {
    if (pondsData != null) {
      const pondArr = [];
      pondsData.forEach((pond) => {
        const pondObj = new Pond();
        pondObj.castToPondObj(pond);
        pondArr.push(pondObj);
      });
      state.ponds = pondArr.sort((a, b) =>
        alphaNumericComparator(a.title, b.title)
      );
    } else {
      state.ponds = null;
    }
  },
  SET_ACTIVE_PONDS_DATA(state, pondsData) {
    if (pondsData != null) {
      const pondArr = [];
      pondsData.forEach((pond) => {
        const pondObj = new Pond();
        pondObj.castToPondObj(pond);
        pondArr.push(pondObj);
      });
      state.activePonds = pondArr;
    } else {
      state.activePonds = null;
    }
  },
  SET_INACTIVE_PONDS_DATA(state, pondsData) {
    if (pondsData != null) {
      const pondArr = [];
      pondsData.forEach((pond) => {
        const pondObj = new Pond();
        pondObj.castToPondObj(pond);
        pondArr.push(pondObj);
      });
      state.inactivePonds = pondArr;
    } else {
      state.inactivePonds = null;
    }
  },
  SET_MAP_PONDID_POND(state) {
    const mapPondidPond = new Map();
    state.ponds.forEach((pond) => {
      mapPondidPond.set(pond.pond_id, pond);
    });
    state.mapPondidPond = mapPondidPond;
  },
  SET_MAP_ACTIVE_PONDID_POND(state) {
    const mapPondidPond = new Map();
    state.activepPonds.forEach((pond) => {
      mapPondidPond.set(pond.pond_id, pond);
    });
    state.mapPondidPond = mapPondidPond;
  },
  PUSH_NEW_POND(state, pondData) {
    const pondObj = new Pond();
    pondObj.castToPondObj(pondData);
    state.ponds.push(pondObj);
    if (!state.mapPondidPond.get(pondObj.pond_id)) {
      state.mapPondidPond.set(pondObj.pond_id, pondObj);
    }
  },
  PUSH_UPDATED_POND(state, pondData) {
    const pondObj = new Pond();
    pondObj.castToPondObj(pondData);
    const index = findIndex(state.ponds, function(pond) {
      return pond.pond_id === pondData.pond_id;
    });
    state.ponds.splice(index, 1, pondObj);
    if (state.mapPondidPond.get(pondObj.pond_id)) {
      state.mapPondidPond.set(pondObj.pond_id, pondObj);
    }
  },

  SET_FEED_TYPES(state, feedTypes) {
    state.feedTypes = feedTypes;
  },
  SET_POND_HEALTH_DATA(state, healthData) {
    state.healthData = healthData;
  },
  SET_ABW_SUMMARY(state, abwSummary) {
    state.abwSummary = abwSummary;
  },
  SET_POND_DATA(state, currentPondData) {
    state.currentPondData = currentPondData;
  },
  SET_MANUAL_FEED_RECORDS(state, arrFeedRecords) {
    state.manualFeedRecords = arrFeedRecords;
  },
  SET_A_POND_MANUAL_FEED_RECORDS(state, arrFeedRecords) {
    state.aPondManualFeedRecords = arrFeedRecords;
  },
  SET_POND_WISE_DEVICE_STATUS(state, pondWiseDeviceStatus) {
    state.pondWiseDeviceStatus = pondWiseDeviceStatus;
  },
};
const actions = {
  fetchNoOfPondsWithoutSchedules: (context, params = {}) => {
    return new Promise((resolve, reject) => {
      PondsService.fetchNoOfPondsWithoutSchedules(params)
        .then((response) => {
          context.commit(
            "SET_PONDS_WITHOUT_SCHEDULES_COUNT",
            response.data.data
          );
          resolve({
            // message: response.data.message,
            // totalPonds: response.data.total,
          });
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchUnstablePhPondCount: (context, params = {}) => {
    return new Promise((resolve, reject) => {
      PondsService.fetchUnstablePhPondCount(params)
        .then((response) => {
          context.commit("SET_UNSTABLE_PH_PONDS_COUNT", response.data.count);
          resolve({
            // message: response.data.message,
            // totalPonds: response.data.total,
          });
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchPondWiseDeviceStatus: (context, params = {}) => {
    return new Promise((resolve, reject) => {
      PondsService.fetchPondWiseDeviceStatus(params)
        .then((response) => {
          context.commit("SET_POND_WISE_DEVICE_STATUS", response.data.ponds);
          resolve({
            // message: response.data.message,
            // totalPonds: response.data.total,
          });
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  fetchLowDoPondCount: (context, params = {}) => {
    return new Promise((resolve, reject) => {
      PondsService.fetchLowDoPondCount(params)
        .then((response) => {
          context.commit("SET_LOW_DO_PONDS_COUNT", response.data.count);
          resolve({
            // message: response.data.message,
            // totalPonds: response.data.total,
          });
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchAllPonds: (context, params = {}) => {
    return new Promise((resolve, reject) => {
      PondsService.fetchAllPonds(params)
        .then((response) => {
          context.commit("SET_PONDS_DATA", response.data.ponds);
          context.commit("SET_MAP_PONDID_POND");
          resolve({
            message: response.data.message,
            totalPonds: response.data.total,
            ponds: response.data.ponds,
          });
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchActivePonds: (context, params = {}) => {
    return new Promise((resolve, reject) => {
      PondsService.fetchActivePonds(params)
        .then((response) => {
          context.commit("SET_ACTIVE_PONDS_DATA", response.data.ponds);
          // context.commit("SET_MAP_PONDID_POND");
          resolve({
            message: response.data.message,
            totalPonds: response.data.total,
          });
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchInactivePonds: (context, params = {}) => {
    return new Promise((resolve, reject) => {
      PondsService.fetchInactivePonds(params)
        .then((response) => {
          context.commit("SET_INACTIVE_PONDS_DATA", response.data.ponds);
          // context.commit("SET_MAP_PONDID_POND");
          resolve({
            message: response.data.message,
            totalPonds: response.data.total,
          });
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchAPond: function(context, pondId) {
    return new Promise((resolve, reject) => {
      $axios
        .get("/ponds/" + pondId)
        .then((response) => {
          context.commit("SET_POND_DATA", response.data.pond);
          resolve(response.data.pond);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchPondHealthData: (context, params) => {
    return new Promise((resolve, reject) => {
      $axios
        .get("/ponds/summary", { params })
        .then((response) => {
          context.commit("SET_POND_HEALTH_DATA", response.data.ponds_summary);
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  savePondDetails: (context, pondDetails) => {
    return new Promise((resolve, reject) => {
      $axios
        .post("/ponds", pondDetails)
        .then(async (response) => {
          context.commit("PUSH_NEW_POND", response.data.pond);
          const pond = nth(context.state.ponds, -1);
          resolve({ pond, message: response.data.message });
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updatePondDetails: async (context, pondDetails) => {
    const url =
      pondDetails.status === "RESET"
        ? `/ponds/${pondDetails.pond_id}/devices`
        : `/ponds/${pondDetails.pond_id}`;
    let response;
    if (pondDetails.status === "RESET") {
      response = await $axios.delete(url);
    } else {
      response = await $axios.patch(url, pondDetails);
    }
    return response.data;
  },
  startCultureDetails: (context, pondDetails) => {
    return new Promise((resolve, reject) => {
      $axios
        .patch(`/ponds/${pondDetails.pond_id}/cultures`, pondDetails)
        .then((response) => {
          // context.commit("PUSH_UPDATED_POND", pondDetails);
          resolve({ message: response.data.message });
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchAllFeedTypes: (context, params = {}) => {
    return new Promise((resolve, reject) => {
      $axios
        .get("/ponds", { params })
        .then((response) => {
          context.commit("SET_FEED_TYPES", [
            {
              name: "A",
              _id: 1,
            },
          ]);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchABWSummary: (context, params = {}) => {
    return new Promise((resolve, reject) => {
      $axios
        .get("ponds/ABW-summary", { params })
        .then((response) => {
          const abwValues = response.data.ponds;
          context.commit("SET_ABW_SUMMARY", abwValues);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  saveABWValues(context, abwSamples) {
    return new Promise((resolve, reject) => {
      $axios
        .post("/ponds/ABW", abwSamples)
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchSlotWisePondFeed: function(context, { pondId, params }) {
    return new Promise((resolve, reject) => {
      $axios
        .get(`/ponds/${pondId}/slotwise-feed`, { params })
        .then((response) => {
          // context.commit('SET_POND_MOTHER_DATA',response.data.pondMothers)
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchHourWisePondFeed: function(context, { pondId, params }) {
    return new Promise((resolve, reject) => {
      $axios
        .get(`/ponds/${pondId}/hourly-feed`, { params })
        .then((response) => {
          // context.commit('SET_POND_MOTHER_DATA',response.data.pondMothers)
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchPondLatestABWValues: async function(context, pondId) {
    try {
      const response = await $axios.get(`/ponds/${pondId}/latest-abw-values`);
      return response.data.pond.latest_records;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  fetchPondABWValues: async function(context, { pondId, ...params }) {
    try {
      const response = await $axios.get(`/ponds/${pondId}/ABW-samples`, {
        params,
      });
      return response.data.ponds_abw_samples;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  /**
   * Actions for Manual Feeding
   */
  fetchAllManualFeedingRecords: async function(context, params) {
    try {
      const response = await $axios.get("/ponds/manual-feed", { params });
      context.commit(
        "SET_MANUAL_FEED_RECORDS",
        response.data.ponds_manual_feed_entries
      );
      return response.data.message;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
  fetchAPondManualFeedingRecords: async function(
    context,
    { pond_id, ...params }
  ) {
    try {
      const response = await $axios.get(`/ponds/${pond_id}/manual-feed`, {
        params,
      });
      context.commit(
        "SET_A_POND_MANUAL_FEED_RECORDS",
        response.data.ponds_manual_feed_entries
      );
      return response.data.ponds_manual_feed_entries;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },

  saveManualFeedingRecords: async function(context, feedRecords) {
    try {
      const response = await $axios.post("/ponds/manual-feed", feedRecords);
      return response.data.message;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
  fetchPondsDeviceStatus: async function(context, params) {
    try {
      const response = await $axios.get("/ponds/device-summary", { params });
      return response.data.ponds;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  fetchAllHarvestLogs: async function(context, params) {
    try {
      const response = await $axios.get("/ponds/harvests", { params });
      return response.data.harvest_logs;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  saveHarvestLog: async function(context, harvestLog) {
    try {
      const response = await $axios.post("/ponds/harvests", harvestLog);
      return response;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  updateHarvestLog: async function(context, harvestLog) {
    try {
      const response = await $axios.patch(
        `/ponds/harvests/${harvestLog.harvest_id}`,
        harvestLog
      );
      return response;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  deleteHarvestLog: async function(context, harvest_id) {
    try {
      const response = await $axios.delete(`/ponds/harvests/${harvest_id}`);
      return response;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  cultureChange: function(context, culture_name) {
    context.commit("SET_CULTURE_ID", culture_name);
  },
  fetchManualFeedDataBasedOnPondId: async function(
    context,
    { pondId, params }
  ) {
    try {
      const response = await $axios.get(`/ponds/${pondId}/manual-feed`, {
        params,
      });
      return response.data.ponds_manual_feed_entries;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  deleteABWRecord: async function(context, abwId) {
    const response = await $axios.delete(`/ponds/ABW/${abwId}`);
    return response.data.message;
  },
  deleteFeedRecord: async function(context, manualFeedRecordId) {
    const response = await $axios.delete(
      `/ponds/manual-feed/${manualFeedRecordId}`
    );
    return response.data.message;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
